'use client'

import { useState, type FC } from 'react'
import type { SelectProps } from 'antd'

import chevronDownIcon from './img/chevron-down-icon.svg'
import chevronUpIcon from './img/chevron-up-icon.svg'

import { SC_SelectWrapper, SC_Select } from './styled'


export type T_SelectProps = SelectProps & {
  name: string
  setFormValue?: (key: string, value: string) => void
  label?: string
  $minWidth?: string
  $isBordered?: boolean
  isGray?: boolean
  onSelect?: (e: any) => void
}

export const Select: FC<T_SelectProps> = (props) => {
  const {
    name,
    setFormValue = () => {},
    label = '',
    $minWidth = '',
    $isBordered = false,
    onSelect = () => {},
    placeholder,
    ...restProps
  } = props

  const [ open, setOpen ] = useState(false)

  return (
    <SC_SelectWrapper>
      {label && (
        <label htmlFor={name}>
          {label}
        </label>
      )}

      <SC_Select
        name={name}
        open={open}
        popupClassName='select-dropdown'
        onDropdownVisibleChange={(o: boolean) => setOpen(o)}
        suffixIcon={
          <img
            src={open ? chevronUpIcon : chevronDownIcon}
          />
        }
        $minWidth={$minWidth}
        placeholder={label || placeholder}
        setFormValue={setFormValue}
        onSelect={onSelect}
        $isBordered={$isBordered}
        {...restProps}
      />
    </SC_SelectWrapper>
  )
}
